import React, { useState, useEffect } from 'react'
import {
  VerticalTimeline,
  VerticalTimelineElement
} from 'react-vertical-timeline-component'
import useMeasure from 'react-use-measure'
import { useSpring, animated } from 'react-spring'
import 'react-vertical-timeline-component/style.min.css'
import './style.scss'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import { useInView } from 'react-intersection-observer'
import clsx from 'clsx'

export const TimelineElement = ({
  idx,
  imgId,
  year,
  name,
  role,
  promise,
  source,
  subheader,
  reality,
  setActiveYear
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true)
  const [refPromise, boundsPromise] = useMeasure()
  const [refReality, boundsReality] = useMeasure()
  const [refMenu, inView] = useInView({ threshold: 0.7 })

  useEffect(() => {
    if (inView) {
      setActiveYear(idx)
    }
  }, [inView])

  const collapsible =
    document.documentElement.clientHeight - (boundsPromise.height + 250) >
    boundsReality.height + 70

  const toggleCollapsed = () => {
    setIsCollapsed(prevState => !prevState)
  }

  const toggleWrapperAnimatedStyle = useSpring({
    transform: isCollapsed ? 'rotate(0deg)' : 'rotate(-180deg)',
    lineHeight: '1em',
    marginTop: 0
  })
  const panelContentAnimatedStyle = useSpring({
    height: isCollapsed
      ? collapsible
        ? boundsReality.height + 70
        : document.documentElement.clientHeight - (boundsPromise.height + 250)
      : boundsReality.height + 70,
    overflow: 'hidden'
  })

  return (
    <VerticalTimelineElement
      className='milestone'
      contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
      contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
      iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
      icon={<i className='icon dot circle large blue' />}
      id={idx}
    >
      <h3 className='vertical-timeline-element-title' ref={refMenu}>
        {year}
      </h3>
      {idx !== 2000 && (
        <div className='person'>
          <img
            className='ui medium circular image'
            src={require('../../images/' + imgId + '.png')}
          />
          <div>
            {name}
            <span className='role'>{role}</span>
          </div>
        </div>
      )}

      <div ref={refPromise}>
        {promise} {idx !== 2000 && <span className='source'>{source}</span>}
      </div>
      {idx !== 2000 && (
        <animated.div className='quote' style={panelContentAnimatedStyle}>
          <h5 style={{ textAlign: 'center' }}>{subheader}</h5>
          <p ref={refReality}>{reality}</p>
          <div
            style={{ visibility: collapsible ? 'hidden' : 'visible' }}
            className={clsx('readmore', isCollapsed && 'gradient')}
            onClick={toggleCollapsed}
          >
            <span>{isCollapsed ? 'weiterlesen' : 'einklappen'}</span>
            <animated.div style={toggleWrapperAnimatedStyle}>
              <i className='angle double down icon' />
            </animated.div>
          </div>
        </animated.div>
      )}

      {/*
            <p className='additional'>
                Vor den Sommerferien wird der Bundesrat die Lage neu beurteilen.
            </p>
            */}
    </VerticalTimelineElement>
  )
}
